import React from "react";
import Fetch from "react-fetch-component/dist/Fetch";
import Component from "./index";
import { cache } from "/store";

export default (props) => {
  return (
    <Fetch url={"/content-api/galleries"} cache={cache}>
      {({ data }) => {
        if (data) {
          return <Component {...data} {...props} />;
        }
        return null;
      }}
    </Fetch>
  );
};
